import { render, staticRenderFns } from "./DebtWriteOffModal.vue?vue&type=template&id=0b5f453e"
import script from "./DebtWriteOffModal.vue?vue&type=script&lang=js"
export * from "./DebtWriteOffModal.vue?vue&type=script&lang=js"
import style0 from "./DebtWriteOffModal.vue?vue&type=style&index=0&id=0b5f453e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports